import React from 'react';
import './LoadingCircles.css';

export default function LoadingCircles() {
	return (
		<div className="loader">
			<div className="outer"></div>
			<div className="middle"></div>
			<div className="inner"></div>
		</div>
	);
}
